/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'infrastructure-vertical-nav';
const prefix = `${moduleName}.${componentName}`;

export const cloudsLabel = `${prefix}.cloudsLabel`;
export const cloudResourcesLabel = `${prefix}.cloudResourcesLabel`;
export const vrfContextLabel = `${prefix}.vrfContextLabel`;
export const networksLabel = `${prefix}.networksLabel`;
export const gslbLabel = `${prefix}.gslbLabel`;
export const sitesLabel = `${prefix}.sitesLabel`;
export const subdomainsLabel = `${prefix}.subdomainsLabel`;
export const geoProfileLabel = `${prefix}.geoProfileLabel`;
export const availabilityZoneLabel = `${prefix}.availabilityZoneLabel`;
export const getStartedLabel = `${prefix}.getStartedLabel`;
export const leaderChangeLabel = `${prefix}.leaderChangeLabel`;

export const ENGLISH = {
    [cloudsLabel]: 'Clouds',
    [cloudResourcesLabel]: 'Cloud Resources',
    [vrfContextLabel]: 'VRF Context',
    [networksLabel]: 'Networks',
    [gslbLabel]: 'GSLB',
    [sitesLabel]: 'Sites',
    [subdomainsLabel]: 'Subdomains',
    [geoProfileLabel]: 'Geo Profile',
    [availabilityZoneLabel]: 'Availability Zone',
    [getStartedLabel]: 'Get Started',
    [leaderChangeLabel]: 'Leader Change',
};
